import { IconProps } from "@/components/Icons/index";

export const AmericanExpressIcon: React.FC<IconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="22"
    viewBox="0 0 32 22"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_24445_6935)">
      <path d="M-1 22H32V0H-1V22Z" fill="#006FCF" style={{ fill: "#006FCF", fillOpacity: "1" }} />
      <path
        d="M17.9696 18.5189L26.6686 18.5373L28.0348 17.0132L29.4108 18.5316H32V16.3078L30.3783 14.559L32 12.826V10.6485L17.9696 10.6359V18.5189Z"
        fill="white"
        style={{ fill: "white", fillOpacity: "1" }}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.9067 17.6546V11.5034H24.1224V12.9204H20.5954V13.8823H24.0383V15.2758H20.5954V16.2206H24.1224V17.6546L18.9067 17.6546Z"
        fill="#006FCF"
        style={{ fill: "#006FCF", fillOpacity: "1" }}
      />
      <path
        d="M29.8622 11.5035L28.0936 13.4531L26.3301 11.5035H24.0963L26.9823 14.5755L24.0963 17.6546H26.2694L28.0458 15.6854L29.8406 17.6546H32V17.5673L29.1754 14.5755L32 11.5519V11.5035H29.8622Z"
        fill="#006FCF"
        style={{ fill: "#006FCF", fillOpacity: "1" }}
      />
      <path
        d="M28.8117 3.63906L28.0892 5.65995L27.3692 3.63906H23.1939V6.33635L22.006 3.63906H18.624L15.1505 11.522H32V3.63906H28.8117Z"
        fill="white"
        style={{ fill: "white", fillOpacity: "1" }}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.4988 8.03142L20.3173 6.07492L21.1353 8.03142H19.4988ZM19.2643 4.49545L16.535 10.6414H18.407L18.9218 9.41077H21.7119L22.2265 10.6414H24.145L21.427 4.49545H19.2643Z"
        fill="#006FCF"
        style={{ fill: "#006FCF", fillOpacity: "1" }}
      />
      <path
        d="M24.1194 10.6404L25.7744 10.6405V6.41877L27.3446 10.6405H28.832L30.3703 6.43311V10.6548L31.9999 10.6405V4.49449H29.4674L28.1047 8.28195L26.7508 4.50355L24.1194 4.49446V10.6404Z"
        fill="#006FCF"
        style={{ fill: "#006FCF", fillOpacity: "1" }}
      />
    </g>
    <defs>
      <clipPath id="clip0_24445_6935">
        <rect
          width="32"
          height="22"
          rx="4"
          fill="white"
          style={{ fill: "white", fillOpacity: "1" }}
        />
      </clipPath>
    </defs>
  </svg>
);
